import { render, staticRenderFns } from "./LogRecordManage.vue?vue&type=template&id=66cf2cfa&scoped=true"
import script from "./LogRecordManage.vue?vue&type=script&lang=js"
export * from "./LogRecordManage.vue?vue&type=script&lang=js"
import style0 from "./LogRecordManage.vue?vue&type=style&index=0&id=66cf2cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf2cfa",
  null
  
)

export default component.exports